import { graphql } from "~/gql";

export const UPDATE_MANY_WORK = graphql(/* GraphQL */ `
  mutation UpdateManyWork($data: [UpdateManyWorkInput!]!) {
    updateManyWork(data: $data) {
      id
      timeSingle
      cost {
        single
      }
    }
  }
`);
